<div *ngIf="panelNum !== 3" class="cas-flex-row p-2">
    <div class="p-col-12">

        <h2>Move Project</h2>
    </div>
    <div class="p-col-12">

        <p>{{project ? project.name : ''}}</p>
    </div>
</div>
<acabim-card *ngIf="panelNum !== 3" [cardHeading]="title" [cardContent]="content"></acabim-card>
<form [formGroup]="moveProjectForm">
    <ng-template #content>
        <ng-container *ngIf="panelNum == 1">
            <div class="cas-flex-row p-2">
                <div class="p-col-12">
                    <div class="cas-flex-row">
                        <div class="p-col-6">
                            <b> Current Site</b>
                        </div>
                        <div class="p-col-6">{{site ? site.name : ''}}
                        </div>
                    </div>
                </div>
                <div class="p-col-12">
                    <hr>
                </div>
                <div class="p-col-12">
                    <div class="cas-flex-row">

                        <div class="p-col-6">
                            <b> New Site</b>
                        </div>
                        <div class="p-col-6">
                            <p-dropdown
                                    [options]="sites"
                                    formControlName="inputDropdownSelected"
                                    [(ngModel)]="selectedSite"
                                    optionLabel="name"
                                    [filter]="true"
                                    placeholder="Select Site"
                                    (onClick)="clearErrorMessage()"
                            ></p-dropdown>
                            <p style="color: red"> {{noSiteMessage}}</p>

                        </div>
                    </div>
                </div>
            </div>
            <p-footer class="cas-form-footer p-2">
                <div class="p-inputgroup cas-form-row">
                    <button (click)="onCancel()" class="cas-form-row">CANCEL</button>
                    <button class="cas-form-row cas-button-action"
                            (click)="navigateToGroupPage()">NEXT
                    </button>
                </div>
            </p-footer>

        </ng-container>
        <ng-container *ngIf="panelNum == 2">
            <div class="cas-flex-row p-2">
                <div class="p-col-12">
                    <b> {{project ? project.name : ''}}</b> will be moved
                    to <b>{{selectedSite ? selectedSite.name : ''}}</b>
                </div>
                <div class="p-col-12">
                    Do you want to remove it from its current group?

                    <p-checkbox class="ml-4" [(ngModel)]="moveGroup" binary="true" inputId="binary"></p-checkbox>

                </div>
            </div>
            <p-footer class="cas-form-footer p-2">
                <div class="p-inputgroup cas-form-row">
                    <button (click)="onCancel()" class="cas-form-row">CANCEL</button>
                    <button class="cas-form-row cas-button-action"
                            (click)="onComplete()">COMPLETE
                    </button>
                </div>
            </p-footer>
        </ng-container>
    </ng-template>
</form>
<div *ngIf="panelNum == 3">
    <div *ngIf="!isLoading else loadingView">
        <h3 class="mt-6"
            style="display: flex; justify-content: center;   align-items: center; margin-top: 20%!important;">
            All Done!</h3>
        <div style="display: flex; justify-content: center;   align-items: center; margin-top: 10%!important;">
            <b> {{project ? project.name : ''}}</b> has been moved
            to <b>{{selectedSite ? selectedSite.name : ''}}</b></div>
        <p-footer style="display: flex; justify-content: center;   align-items: center; margin-top: 10%!important;">
            <button (click)="onCancel()" class="cas-button-action">CLOSE
            </button>
        </p-footer>
    </div>

</div>


<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
